module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalTheme', {
    attrs: {
      "with-content": true,
      "theme": true,
      "fix-height": false,
      "fix-width": false,
      "auto-width": true,
      "max-width": "90vw"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('template', {
    slot: "main"
  }, [_c('ItemDescription', {
    attrs: {
      "item": _vm.item,
      "forecast": _vm.forecast
    }
  }), _vm._v(" "), _c('ItemImage', {
    attrs: {
      "item": _vm.item
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('ItemQuantities', {
    attrs: {
      "itemId": _vm.item.id,
      "forecast": _vm.forecast,
      "full": false
    }
  })], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33eb41d8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/catalogue/ItemQuantitiesModal.vue
// module id = 3114
// module chunks = 0